import { HttpClient } from '@angular/common/http';
import { Inject, Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { catchError, finalize, tap } from 'rxjs/operators';
import { MessageService } from '../../../core/service/message.service';
import { ProgressBarService } from '../../../core/service/progress-bar.service';
import { Transfer } from '../../model/Transfer/transfer';
import { CooperativeHousingContract } from '../../model/cooperative-housing-contract';
import { APP_CONFIG, IAppConfig } from './../../../app.config';
import { ContractService } from './../base/contract';

@Injectable()
export class CooperativeHousingContractService extends ContractService<CooperativeHousingContract> {
  createTransfer(context: Transfer): Observable<string> {
    this.progressBar.start();
    return this.client.post<string>(`${this.endpoint}/transfer`, JSON.stringify(context)).pipe(
      tap(() => {
        this.notification.showSuccess();
      }),
      catchError(e => {
        this.notification.showError(e);
        throw e;
      }),
      finalize(() => this.progressBar.stop())
    );
  }

  getTransferDefaults(leaseAgreementId: string): Observable<Transfer> {
    this.progressBar.start();
    return this.client.get<Transfer>(`${this.endpoint}/transfer/${leaseAgreementId}`).pipe(finalize(() => this.progressBar.stop()));
  }

  constructor(client: HttpClient, @Inject(APP_CONFIG) config: IAppConfig, messageService: MessageService, progressBar: ProgressBarService) {
    super(client, config, messageService, CooperativeHousingContract, progressBar, 'co-housing-contract', 'Bostadsrattskontrakt.xlsx');
  }
}
